export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5155.bd3d5e73.jpg";